import React, { useEffect, useState } from 'react';
import { useMediaQuery } from "react-responsive";

import SlButton from '@shoelace-style/shoelace/dist/react/button';
import { MdAutoFixHigh, MdOutlineDocumentScanner, MdOutlineFilterAlt } from "react-icons/md";
import { FiTable } from "react-icons/fi";

import FileDropZone from '../../components/FileDropZone/FileDropZone';
import DialogError from '../../components/DialogError/DialogError';
import DividerHeading from '../../components/DividerHeading/DividerHeading';
import FileHistory from '../../components/FileHistory/FileHistory';

import { safeRetrieve } from '../../utils/safeStoring';
import { makeToast } from '../../utils/makeToast';
import { sPullFile } from '../../utils/sPullFile';
import { getIndexAll, dBridgeTableInsert, dBridgeTableDelete } from '../../utils/dbridge_iface';
import { historyConf } from './historyConf';


function LetturaDM10 () {


    // const dummyHistory = [
    //     {
    //         dm10_reading_id: 1,
    //         file_s3_key: "2024-05-report-001.csv",
    //         entity: "Entity_X",
    //         period: "Settembre 2024",
    //         created_at: "2024-06-11 10:11:21"
    //     },
    //     {
    //         dm10_reading_id: 2,
    //         file_s3_key: "2024-05-report-002.csv",
    //         entity: "Entity_Y",
    //         period: "2024-Q2",
    //         created_at: "2024-06-11 15:26:42",   // Same day as previous
    //         isNew: true
    //     },
    //     {
    //         dm10_reading_id: 3,
    //         file_s3_key: "2024-06-report-001.csv",
    //         entity: "Entity_X",
    //         period: "2024-Q2",
    //         created_at: "2024-06-08 09:02:10"
    //     },
    //     {
    //         dm10_reading_id: 4,
    //         file_s3_key: "2024-04-report-008.csv",
    //         entity: "Entity_Z",
    //         period: "2024-Q1",
    //         created_at: "2024-05-27 14:37:50"
    //     }
    // ];


    const isColumnLayout = useMediaQuery({ maxWidth: 900 });
    
    const [isOpenError, setIsOpenError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([
        // {"fileName": "This is a long title for a document.docx", 's3Key': '', 'uploaded': false, 'deleting': false}
    ]);
    const [isWaitingResponse, setIsWaitingResponse] = useState(false);

    const [history, setHistory] = useState([]);


    useEffect(() => {
        // retrieve history from the database
        getIndexAll('dm10_reading')
        .then((res) => {
            console.log('History retrieved successfully', res);
            setHistory(res);
        })
    }, []);


    const handleConvertion = () => {
    
        // check if there are files to send
        if (uploadedFiles.length === 0) {
          return;
        }
    
        // check if all files are uploaded
        if (!uploadedFiles.every(file => file.uploaded)) {
          return;
        }
    
        setIsWaitingResponse(true);

        const apiUrl = process.env.REACT_APP_API_URL || '';
        const apiKey = safeRetrieve('APIKEY_v2');
        fetch(`${apiUrl}/api/extractor/v1/dm10_reading`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                files_s3_keys: uploadedFiles.map(file => file.s3Key)
            }),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error in dm10_reading response: ${response.status}`, errorData);
                    // makeToast(`C'è stato un errore nel processo di conversione, per favore controlla che il documento caricato sia conforme ai requisiti. Se necessario, contatta l'amministratore di sistema.`, 'warning');
                    setIsOpenError(true);
                    setIsWaitingResponse(false);
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            // add a new entry to the database
            const resultEntry = {
                "file_s3_key": data.body.s3_key,
                "codice_fiscale": data.body.metadata.codice_fiscale,
                "data_denuncia": data.body.metadata.data_denuncia,
                "somma_debito": data.body.metadata.somma_debito
            }
            dBridgeTableInsert('dm10_reading', resultEntry)
            .then((insertedEntry) => {
                if (Object.keys(insertedEntry).length > 0) {
                    console.log('Entry inserted successfully', resultEntry);
                    // concatenate the new entry on top of the existing history
                    insertedEntry.isNew = true;
                    setHistory([insertedEntry, ...history]);
                    setIsWaitingResponse(false);
                } else {
                    console.log('Entry not inserted', resultEntry);
                    setIsOpenError(true);
                    setIsWaitingResponse(false);
                }
            })
        })
        .catch((error) => {
            console.error('Request failed:', error);
            makeToast('Si è verificato un errore di rete. Per favore riprova più tardi.', 'warning');
            setIsWaitingResponse(false);
        });
    
    }


    const handleHistoryDownload = (entry) => {
        sPullFile(entry.file_s3_key);
    }


    const handleHistoryDelete = (entry) => {
        dBridgeTableDelete('dm10_reading', 'dm10_reading_id', entry.dm10_reading_id)
        .then((success) => {
            if (success) {
                console.log('Entry deleted successfully', entry);
                // remove entry from history
                const newHistory = history.filter(item => item.dm10_reading_id !== entry.dm10_reading_id);
                setHistory(newHistory);
            } else {
                console.log('Entry not deleted', entry);
            }
        })
    }
    


    const ExtractButton = () => {
        return (
            <SlButton 
                variant="primary"
                size="large"
                pill
                className="btn-primary"
                style={{ alignSelf: 'center' }}
                loading={isWaitingResponse}
                onClick={handleConvertion}
                disabled={
                    !(uploadedFiles.every(file => file.uploaded)) 
                    || (uploadedFiles.length === 0)
                }
            >
                <MdAutoFixHigh className='icon' />
                <span>Estrai dati DM10</span>
            </SlButton>
        );
    };



    return (

        <div className="page-F24Datev">
            
            <div className='top-row' style={{ flexDirection: `${isColumnLayout ? 'column' : 'row'}` }} >

                <div className='top-row-left' style={{ flex: 3 }}>

                    <span className='title'>
                        Estrai dati anagrafici e saldo dal DM10
                    </span>
                    <span>
                        Carica i file DM10 per ottenere automaticamente le informazioni anagrafiche aziendali e il saldo dovuto. Il tool identifica l’intestatario, il mese di riferimento e calcola il totale (solitamente a debito) da versare.
                    </span>
                    <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                        <li>
                            <div className='icon'><MdOutlineDocumentScanner /></div>
                            <span><strong>Lettura automatica</strong> - Nessuna necessità di conversioni manuali, il tool legge direttamente il formato nativo.</span>
                        </li>
                        <li>
                            <div className='icon'><FiTable /></div>
                            <span><strong>Dati completi</strong> - Ottieni intestazione, matricola e saldo in un attimo.</span>
                        </li>
                        {/* TODO: uncomment this when filters are implemented */}
                        {/* <li>
                            <div className='icon'><MdOutlineFilterAlt  /></div>
                            <span><strong>Filtro per periodo</strong> - Ricerche rapide per mese e anno.</span>
                        </li> */}
                    </ul>

                    {!isColumnLayout && (
                        <ExtractButton />
                    )}
                
                </div>

                {/* TODO: aggiungere filtro */}

                <div className='top-row-right' style={{ flex: 7 }}>

                    <FileDropZone 
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        useCaseName="dm10-reading"
                        isWaiting={isWaitingResponse}
                    />
                
                </div>

                {isColumnLayout && (
                    <ExtractButton />
                )}

            </div>

            {history.length > 0 && (
                <>
                <DividerHeading text="Storico elaborazioni" />

                <FileHistory
                    data={history}
                    datetimeField={historyConf.datetimeField}
                    showInfo={historyConf.showInfo}
                    onDownload={handleHistoryDownload}
                    onDelete={handleHistoryDelete}
                />
                </>
            )}

            <DialogError 
                isOpen={isOpenError}
                setIsOpen={setIsOpenError}
            />
        
        </div>

    );
}

export default LetturaDM10;
